/*********************************************************************
* © Copyright IBM Corp. 2024
*********************************************************************/
import {EnhancedAuditEvent} from '../../ConfigurationList'
import intl from '../../utils/intl/intl'
import {BuildMessage} from '../areaContracts'
import {DetailedViewEventTypeDependent} from './detailedViewKnownEventTypes'

const prefixes: DetailedViewEventTypeDependent<string> = {
  detailedViewEnabled: intl.formatMessage('Enabled'),
  detailedViewDisabled: intl.formatMessage('Disabled'),
  detailedViewUpdated: intl.formatMessage('Updated'),
  detailedViewRestoredToDefault: intl.formatMessage('Restored to default')
}

export const buildDetailedViewMessage: BuildMessage = async (
  auditEvent: EnhancedAuditEvent,
  {termService}
) => {
  // nosemgrep: eslint.detect-object-injection
  const prefix = prefixes[auditEvent.eventType]
  const term = await termService.getTerm(
    auditEvent.discriminator1!,
    auditEvent.discriminator2 ? Number(auditEvent.discriminator2) : undefined
  )

  const message = prefix
    ? intl.formatMessage(`{prefix} detailed view for {term}`, {prefix, term})
    : intl.formatMessage(`{eventType} event occurred for detailed view of {term}`, {eventType: auditEvent.eventType, term})

  return auditEvent.processName
    ? intl.formatMessage(`{message} in {processName} process`, {message, processName: auditEvent.processName})
    : message
}
